import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("C:/Duhan Projects/teknopark-site/layouts/default.vue").then(m => m.default || m))
}